import {writable} from 'svelte/store';

const createStore = () => {
  const {subscribe, set, update} = writable({help: null, changing: false});

  const change = (help) => {
    set({help, changing: true});
    setTimeout(clearChanging, 500);
  };

  const clearChanging = () => {
    update((old) => {
      old.changing = false;
      return old;
    });
  };

  return {
    subscribe,
    change
  };
};

export const helpStore = createStore();
